import { PayloadAction } from "@reduxjs/toolkit";
import { ReccurrenceEditItem } from "../../EditReccurrenceForm/Types";
import { OutputConfigPickerItem } from "../../OutputConfigPicker/Types";
import {
  IInitialState,
  ScheduleDetails,
  ISchedueListResponse,
  SchedulingModes,
  IScheduleInstanceType
} from "./Types";

export const Reducer = {
  setScheduleListPage: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.isScheduleListPage = action.payload;
  },
  seSchedulingMode: (state: IInitialState, action: PayloadAction<SchedulingModes>): void => {
    state.mode = action.payload;
  },
  setIsEndByEnabled: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.isEndBy = action.payload;
  },
  setIsEndAfterEnabled: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.isEndAfter = action.payload;
  },
  setNewScheduleDetails: (state: IInitialState, action: PayloadAction<ScheduleDetails>): void => {
    state.schedulingDetails = action.payload;
  },
  setScheduleList: (state: IInitialState, action: PayloadAction<ISchedueListResponse>): void => {
    state.scheduleList = action.payload;
  },
  setscheduleInstances: (state: IInitialState, action: PayloadAction<IScheduleInstanceType[]>): void => {
    state.scheduleInstances = action.payload;
  },
  setIsValidScheduleName: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.isValidScheduleName = action.payload;
  },
  /**
   * To set show/hide scheduling popup
   * @param state Initial state
   * @param action Flag to show popup 
   */
  setShowSchedulingPopup: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.isShowSchedulePopup = action.payload;
  },
  /**
   * To set scheduling recurrence item
   * @param state Initial state
   * @param action Scheduling recurrence item as payload
   */
  setSchedulingRecurrenceItem: (state: IInitialState, action: PayloadAction<ReccurrenceEditItem>): void => {
    state.schedulingRecurrenceItem = action.payload;
  },
  /**
   * Set selected scheduling id
   * @param state Initial state
   * @param action Scheduling id as payload
   */
  setSchedulingId: (state: IInitialState, action: PayloadAction<number>): void => {
    state.schedulingId = action.payload;
  },
  /**
   * To set flag enable scheduling popup save 
   * @param state Initial state
   * @param action Flag to enable scheduling popup save 
   */
  enableSchedulingPopupSave: (state: IInitialState, action: PayloadAction<boolean>): void => {
    state.enableSchedulingPopupSave = action.payload;
  },
  /**
   * To set output config picker list
   * @param state Initial state
   * @param action Output config picker items
   */
  setPickerConfigList: (state: IInitialState, action: PayloadAction<OutputConfigPickerItem[]>): void => {
    state.pickerConfigList = action.payload;
  },
  /**
   * To set the updated schedule instance
   * @param state IInitial state
   * @param action Schedule instances
   */
  setUpdatedScheduleInstance: (state: IInitialState, action: PayloadAction<IScheduleInstanceType>): void => {
    const scheduleInstanceList = [...state.scheduleInstances];
    const scheduleInstanceIndex = scheduleInstanceList.findIndex(
      (item: IScheduleInstanceType) => item.id === action.payload.id);
    scheduleInstanceList[scheduleInstanceIndex] = action.payload;
    state.scheduleInstances = scheduleInstanceList;
  }
};
